"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = void 0;
exports.Color = {
    jaune: "#FCAE3B",
    bleu: "#28348a",
    vert: "#1AA981",
    themeColor: "#3a7dbb ",
    success: "#3a7dbb ",
    default: "#3a7dbb ",
    danger: "##fa1414",
    rouge: "##fa1414",
    white: "#fff",
};
